import { readItems } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();
export const getConfig = async () => {
    const response = await directus.request(
      readItems("configuracion", {
        fields: "signo_moneda,omitir_1,data_remoto",
        sort: "-date_created",
        limit: -1,
      })
    );    
    return response;
  };